/* eslint-disable jsx-a11y/label-has-associated-control */
import {
	 Alert, Button, Modal
} from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Component for Unsubscribe - Unsubscribing from notifications
 *
 * @class Unsubscribe
 * @extends {Component}
 */
const ResubscribeEmailConfirmation = ({
	directAddress, errorMsg, onCloseSendResubscribeEmailModal, sendResubscribeEmail
}) => {
	let alert = null;

	if (errorMsg) {
		const alertProps = {
			children: errorMsg,
			type: 'danger',
			visible: true,
			dismissable: false
		};
		alert = <Alert {...alertProps} />;
	}

	const content = (
		<div className='container'>
			{alert}
			<span className='mt-2'>
				Are you sure you want to send an email to
				{' '}
				<b>{directAddress}</b>
				{' '}
				with a resubscription link?
			</span>
		</div>
	);

	return (
		<Modal
			title='Send Resubscribe Email'
			content={content}
			show
			classNames='resubscribeEmailModal'
			onClose={() => onCloseSendResubscribeEmailModal()}
			closeLabel='Cancel'
			buttons={[
				<Button
					id='unsubscribe'
					key='unsubscribe'
					className='btn-success'
					onClick={() => sendResubscribeEmail()}
				>
					Send
				</Button>]}
		/>
	);
};

ResubscribeEmailConfirmation.propTypes = {
	id: PropTypes.string,
	directAddress: PropTypes.string,
	sendResubscribeEmail: PropTypes.func.isRequired,
	onCloseSendResubscribeEmailModal: PropTypes.func.isRequired
};

export default ResubscribeEmailConfirmation;
